import {z} from "zod"
import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {box2Like, remotelyColorLike, vector2Like} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/basic-definitions"

export const BrushSettings = z.object({
    color: remotelyColorLike,
    width: z.number().min(0),
    hardness: z.number().min(0).max(1).optional().default(0.8),
})

export type BrushSettings = z.infer<typeof BrushSettings>

export const BrushStroke = z.object({
    settings: BrushSettings,
    path: z.array(vector2Like),
})

export type BrushStroke = z.infer<typeof BrushStroke>

export const definition = {
    validation: {
        returns: z.object({
            resultImage: anyImageOpResult,
            boundingBox: box2Like,
        }),
        parameters: z.object({
            sourceImage: anyImageOpResult,
            brushStrokes: z.array(BrushStroke),
            options: z
                .object({
                    tilingEnabled: z.boolean().optional().default(true),
                })
                .optional()
                .default({}),
        }),
    },
}
